export const discountTypes = {
  PERCENTAGE: 'percentage',
  FIXED: 'fixed_amount',
};
